<template>
  <custom-dialog class="project-item-dialog" :title="model.title" width="600px" :visible="visible" v-on="$listeners" appendToBody>
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col>
            <el-form-item :label="$t('components_projectTagDialog.biao_qian_ming_cheng')" prop="tagName">
              <el-input v-model="form.tagName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  components: {},

  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        orgId: '',
        orgName: '',
        tagId: '',
        tagName: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        tagName: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      if (this.model.type === 'add') {
        this.add();
      } else {
        this.edit();
      }
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationTagUpdate, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success');
          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationTagAdd, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.$emit('success');
          });
        }
      });
    },

    initForm() {
      // if (this.model.type === 'add') {
      //   return;
      // }

      this.$setFormatData(this.form, this.model.data);
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>

<style lang="scss">
.project-item-dialog {
}
</style>
